import React from "react";
import 'twin.macro';

const Circle = ({ ...props }) => {
    return (
        <div {...props} 
            data-id="circle"
            tw="rounded-full w-5 h-5">
        </div>
    );
};

export default Circle;
